export const Granted = 'granted'
export const Prompt = 'prompt'
export const Denied = 'denied'
